import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-000f3644"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-pic-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Lv. 1", -1))

import { Item } from "@/types";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    character: null
  },
  setup(__props: any) {

const props = __props as { character: Item }

_useCssVars(_ctx => ({
  "4dd1a9ca": (_unref(raritySrc))
}))


const icons = (path: string) => {
  const i = require.context("@/assets/images/icons/", false, /\.webp$/);
  try {
    return i(path);
  } catch (err) {
    return path;
  }
};

const elementSrc = computed(() => {
  const images = require.context("@/assets/images/icons", false, /\.webp$/);
  try {
    return images(`./icon-element-${props.character.element}.webp`);
  } catch (error) {
    return `./icon-element-${props.character.element}.webp`;
  }
});

const raritySrc = computed(() => {
  const images = require.context("@/assets/images/icon-bgs", false, /\.webp$/);
  try {
    return `url(${images(`./${props.character.rarity}star.webp`)})`;
  } catch (error) {
    return `./${props.character.rarity}star.webp`;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "element",
      src: _unref(elementSrc)
    }, null, 8, _hoisted_2),
    _createElementVNode("img", {
      class: "profile",
      src: icons(`./${__props.character.id}.webp`)
    }, null, 8, _hoisted_3),
    _hoisted_4
  ]))
}
}

})